// @flow

const minLength = (errorMessage: string = 'Error') => (min: number) => (value: string) => (value && value.length < min ? `${errorMessage}: ${min}` : undefined);

export const minLength1 = (errorMessage: string = 'Error') => minLength(errorMessage)(1);

export const selectLength = (errorMessage: string = 'Error') => (value: string) => (!value || value.length < 1 ? (errorMessage || 'Please pick an option') : undefined);

export default null;
